'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _redboxReact2 = require('redbox-react');

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require('react');

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require('react-transform-catch-errors');

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _class, _temp;

var _reactRouter = require('react-router');

var _textEllipsis = require('text-ellipsis');

var _textEllipsis2 = _interopRequireDefault(_textEllipsis);

var _helpers = require('helpers');

var _constants = require('redux/constants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
    SliderCategoryItem: {
        displayName: 'SliderCategoryItem'
    }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
    filename: '/usr/local/ibonus/src/components/GoodsSlider/default/SliderCategoryItem.jsx',
    components: _components,
    locals: [],
    imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
    return function (Component) {
        return _reactTransformCatchErrors2(Component, id);
    };
} /**
   * Created by maximus on 10.01.17.
   */

// TODO: если этот слайдер будет использоваться, то нужно будет сделал проверку на актуальность категорий, пример:
// components/Menu - там по клику рефрешим список категорий
var SliderCategoryItem = _wrapComponent('SliderCategoryItem')((_temp = _class = function (_Component) {
    (0, _inherits3.default)(SliderCategoryItem, _Component);

    function SliderCategoryItem() {
        (0, _classCallCheck3.default)(this, SliderCategoryItem);
        return (0, _possibleConstructorReturn3.default)(this, (SliderCategoryItem.__proto__ || (0, _getPrototypeOf2.default)(SliderCategoryItem)).apply(this, arguments));
    }

    (0, _createClass3.default)(SliderCategoryItem, [{
        key: 'render',
        value: function render() {
            var _props$category = this.props.category,
                id = _props$category.id,
                title = _props$category.title,
                pictures = _props$category.pictures;

            var imgSrc = (0, _helpers.checkPicture)(pictures);

            return _react3.default.createElement(
                'div',
                { className: 'product-item-holder hover' },
                _react3.default.createElement(
                    'div',
                    { className: 'product-item' },
                    _react3.default.createElement(
                        'div',
                        { className: 'image' },
                        _react3.default.createElement(
                            _reactRouter.Link,
                            { to: '/category/' + id + '/' + _constants.CatalogNumericConstants.CATEGORY_PAGE_LIMIT + '/0' },
                            _react3.default.createElement('img', { alt: '', src: imgSrc })
                        )
                    ),
                    _react3.default.createElement(
                        'div',
                        { className: 'body' },
                        _react3.default.createElement('div', { className: 'label-discount clear' }),
                        _react3.default.createElement(
                            'div',
                            { className: 'title text-center' },
                            _react3.default.createElement(
                                _reactRouter.Link,
                                { to: '/category/' + id + '/' + _constants.CatalogNumericConstants.CATEGORY_PAGE_LIMIT + '/0' },
                                _react3.default.createElement(
                                    'span',
                                    { className: 'visible-lg text-theme-color' },
                                    (0, _textEllipsis2.default)(name, 160, { ellipsis: '...' })
                                ),
                                _react3.default.createElement(
                                    'span',
                                    { className: 'hidden-lg hidden-xs text-theme-color' },
                                    (0, _textEllipsis2.default)(name, 80, { ellipsis: '...' })
                                ),
                                _react3.default.createElement(
                                    'span',
                                    { className: 'visible-xs text-theme-color' },
                                    (0, _textEllipsis2.default)(name, 120, { ellipsis: '...' })
                                )
                            )
                        )
                    )
                )
            );
        }
    }]);
    return SliderCategoryItem;
}(_react2.Component), _class.propTypes = {
    category: _react2.PropTypes.object
}, _temp));

exports.default = SliderCategoryItem;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/GoodsSlider/default/SliderCategoryItem.jsx
// module id = 1664
// module chunks = 0